import React, { useState } from "react";
import styled from "styled-components";
import { EstiloButton } from "./App";
import logoCata from "./assets/logo_cata.png";
import { useData } from "./DataContext";
import { Alert, CloseButton } from "./App";

const ContenedorCosto = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  margin: 1rem 1rem 4rem 1rem;
  p {
    margin: 0;
    font-size: small;
  }
`;
const ResultadoCostoViatico = styled.div`
  width: 145px;
  background-repeat: no-repeat;
  background-size: 100%;
`;
const ResultadoTotal = styled.p`
  font-size: medium;
`;
const ContenedorDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    display: none;
  }
`;
const ResultadoLine = styled.div`
  margin: 6px 0 6px;
  width: 100%;
  height: 1px;
  background-color: rgb(0, 0, 0);
`;
const ContenedorFormBase = styled.div`
  text-align: left;
  width: 380px;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 330px;
  }
`;
const FormGroup = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin: 7px 0px 7px 0px;
  align-items: flex-end;
  & label {
    font-size: small;
    font-weight: bold;
  }
  & input,
  select,
  textarea {
    border: none;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    transition: 0.3s;
    border-radius: 2px;
    width: 200px;
    &:focus {
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
    }
  }
`;
const ResultadoCosto = styled.div`
  width: 300px;
  height: 500px;
`;
const ResultadoCostoTexto = styled.div`
  position: fixed;
  text-align: justify;
  background-color: #6161612f;
  border-radius: 3px;
  background-image: url(${logoCata});
  background-repeat: no-repeat;
  background-size: 100%;
  width: 260px;
  height: 440px;
  padding: 1rem;
  p {
    font-size: medium;
  }
  h5 {
    margin-top: 3rem;
    text-align: center;
  }
  @media (max-width: 1020px) {
    position: static;
  }
`;

const CostCalculadora = () => {
  /*///////////////dataContext/////////////////////////*/
  const {
    fechaData,
    sueldoData,
    viaticosNacionalesData,
    viaticosInternacionalesData,
    viaticoData,
    costoUnidadesData,
    peajeData,
  } = useData();
  const sueldoChofer = sueldoData[0]?.sueldo;
  const peajeMdzCaba = peajeData[0]?.peaje;
  const fechaActualizacion = fechaData[0]?.fecha;
  const viaticoProvincial = viaticoData[0]?.viatico;
  const {
    almuerzo: almuerzoNacional,
    cama: camaNacional,
    cena: cenaNacional,
    desayuno: desayunoNacional,
    merienda: meriendaNacional,
  } = viaticosNacionalesData[0] || {};
  const totalViaticosNacionales =
    almuerzoNacional +
    camaNacional +
    cenaNacional +
    desayunoNacional +
    meriendaNacional;

  const {
    almuerzo: almuerzoInternacional,
    cama: camaInternacional,
    cena: cenaInternacional,
    desayuno: desayunoInternacional,
    merienda: meriendaInternacional,
  } = viaticosInternacionalesData[0] || {};
  const totalViaticosInternacionales =
    almuerzoInternacional +
    camaInternacional +
    cenaInternacional +
    desayunoInternacional +
    meriendaInternacional;

  const {
    costoBusDoble: costoBusDobleData,
    costoBus40: costoBus40Data,
    costoVan19: costoVan19Data,
    costoMiniBus: costoMiniBusData,
  } = costoUnidadesData[0] || {};

  /*////////////////////////////////////////*/

  const [calculated, setCalculated] = useState(false);
  const [bus, setBus] = useState("BusDoble");
  const [costoAdquisicion, setCostoAdquisicion] = useState("449000");
  const [precioDolar, setPrecioDolar] = useState("");
  const [precioCombustible, setPrecioCombustible] = useState("");
  const [consumo, setConsumo] = useState("0.45");
  const [precioUrea, setPrecioUrea] = useState("");
  const [costoCubiertas, setCostoCubiertas] = useState("");
  const [impuestoAutomotor, setImpuestoAutomotor] = useState("");
  const [sueldoPersonal, setSueldoPersonal] = useState(sueldoChofer);
  const [seguroMensual, setSeguroMensual] = useState("");
  const [viaticosJornadaCompleta, setViaticosJornadaCompleta] =
    useState(viaticoProvincial);
  const [precioLubricante, setPrecioLubricante] = useState("");
  const [peajes, setPeajes] = useState(peajeMdzCaba);

  /*////////////////////////////////////////*/

  const [costoFinanciero, setCostoFinanciero] = useState("0");
  const [combustible, setCombustible] = useState("0");
  const [costoUrea, setCostoUrea] = useState("0");
  const [neumaticos, setNeumaticos] = useState("0");
  const [impuestos, setImpuestos] = useState("0");
  const [personal, setPersonal] = useState("0");
  const [seguro, setSeguro] = useState("0");
  const [viaticos, setViaticos] = useState("0");
  const [lubricante, setLubricante] = useState("0");
  const [mantenimiento, setMantenimiento] = useState("0");
  const [peajesGastos, setPeajesGastos] = useState("0");
  const [gastosVarios, setGastosVarios] = useState("0");
  const [pesoPorKilometro, setPesoPorKilometro] = useState("0");
  const [showAlert, setShowAlert] = useState(false);
  const closeAlert = () => {
    setShowAlert(false);
  };

  const validarNumero = (numero) => {
    const valorNumerico = parseFloat(numero);
    return !isNaN(valorNumerico) && valorNumerico >= 0;
  };

  const calcularCostos = () => {
    if (
      !bus ||
      !validarNumero(costoAdquisicion) ||
      !validarNumero(precioDolar) ||
      !validarNumero(precioCombustible) ||
      !validarNumero(consumo) ||
      !validarNumero(precioUrea) ||
      !validarNumero(costoCubiertas) ||
      !validarNumero(impuestoAutomotor) ||
      !validarNumero(sueldoPersonal) ||
      !validarNumero(seguroMensual) ||
      !viaticosJornadaCompleta ||
      !validarNumero(precioLubricante) ||
      !validarNumero(peajes)
    ) {
      setShowAlert(true);
      return;
    }

    const busValue = bus;
    const costoAdquisicionValue = parseFloat(costoAdquisicion);
    const precioDolarValue = parseFloat(precioDolar);
    const precioCombustibleValue = parseFloat(precioCombustible);
    const consumoValue = parseFloat(consumo);
    const precioUreaValue = parseFloat(precioUrea);
    const costoCubiertasValue = parseFloat(costoCubiertas);
    const impuestoAutomotorValue = parseFloat(impuestoAutomotor);
    const sueldoPersonalValue = parseFloat(sueldoPersonal);
    const seguroMensualValue = parseFloat(seguroMensual);
    const viaticosJornadaCompletaValue = parseFloat(viaticosJornadaCompleta);
    const precioLubricanteValue = parseFloat(precioLubricante);
    const peajesValue = parseFloat(peajes);
    /*////////////////////////////////////////*/

    const kmAnuales =
      busValue === "BusDoble" ? 150000 : busValue === "Bus40" ? 90000 : 65000;
    const costoAdquisicionCalculado = costoAdquisicionValue * precioDolarValue;
    const tasaDepreciacion20 = costoAdquisicionCalculado * 0.2;
    const bienesPersonales0_5 = costoAdquisicionCalculado * 0.005;
    const costoFinancieroValue =
      (tasaDepreciacion20 + bienesPersonales0_5) / kmAnuales;
    const combustibleValue =
      (kmAnuales * consumoValue * precioCombustibleValue) / kmAnuales;
    const costoUreaValue =
      busValue === "BusDoble"
        ? (kmAnuales * 0.0225 * precioUreaValue) / kmAnuales
        : busValue === "Bus40"
        ? (kmAnuales * 0.0175 * precioUreaValue) / kmAnuales
        : 0;
    //costo cubiertas x 6 cubiertas / 60mil km si es la van, 6 cubiertas y 120mil km si es Bus40 y Bus Doble 8 cubiertas y 120mil km
    const neumaticosValue =
      busValue === "Van19"
        ? (costoCubiertasValue * 6) / 60000
        : busValue === "Bus40"
        ? (costoCubiertasValue * 6) / 120000
        : (costoCubiertasValue * 8) / 120000;
    //impuesto automotor = $ x km patente fedeeac
    const impuestosValue = impuestoAutomotorValue;
    const personalFactor = busValue === "BusDoble" ? 2 : 1;
    const personalValue =
      ((sueldoPersonalValue * 0.6 + sueldoPersonalValue) *
        1.083 *
        12 *
        personalFactor) /
      kmAnuales;
    //seguro = $ x km seguro fedeeac
    const seguroValue = seguroMensualValue;
    const viaticosValue = viaticosJornadaCompletaValue / 550;
    const lubricanteValue =
      busValue === "Van19"
        ? (precioLubricanteValue * 11) / 10000
        : (precioLubricanteValue * 20) / 15000;
    const mantenimientoValue = (costoAdquisicionCalculado * 0.1) / kmAnuales;
    const peajesGastosValue = peajesValue / 1100;
    /*Gastos Varios = Costo Financiero: 2% - Combustible: 25% - Neumáticos: 5% - Impuestos: 8% - Personal: 15% - Seguro: 7% - Viáticos: 2% - Lubricante: 3% - Mantenimiento: 20% - Peajes: 3% */
    const gastosVariosValue =
      costoFinancieroValue * 0.02 +
      combustibleValue * 0.25 +
      neumaticosValue * 0.05 +
      impuestosValue * 0.08 +
      personalValue * 0.15 +
      seguroValue * 0.07 +
      viaticosValue * 0.02 +
      lubricanteValue * 0.03 +
      mantenimientoValue * 0.2 +
      peajesGastosValue * 0.03;

    const pesoPorKilometroValue =
      costoFinancieroValue +
      combustibleValue +
      costoUreaValue +
      neumaticosValue +
      impuestosValue +
      personalValue +
      seguroValue +
      viaticosValue +
      lubricanteValue +
      mantenimientoValue +
      peajesGastosValue +
      gastosVariosValue;

    setCalculated(true);
    setBus(busValue);
    setPrecioDolar(precioDolarValue);
    setCostoFinanciero(costoFinancieroValue);
    setCombustible(combustibleValue);
    setCostoUrea(costoUreaValue);
    setNeumaticos(neumaticosValue);
    setImpuestos(impuestosValue);
    setPersonal(personalValue);
    setSeguro(seguroValue);
    setViaticos(viaticosValue);
    setLubricante(lubricanteValue);
    setMantenimiento(mantenimientoValue);
    setPeajesGastos(peajesGastosValue);
    setGastosVarios(gastosVariosValue);
    setPesoPorKilometro(pesoPorKilometroValue);
  };

  return (
    <ContenedorCosto>
      {showAlert && (
        <Alert>
          <CloseButton onClick={closeAlert}>&times;</CloseButton>
          Por favor, complete los campos vacios y verifique que no sean números
          negativos.
        </Alert>
      )}
      <ResultadoCostoViatico>
        <ContenedorDiv>
          <div>
            <h5>Costos:</h5>
            <p>
              Actualización{" "}
              {new Date(
                new Date(fechaActualizacion).toLocaleString("en-US", {
                  timeZone: "UTC",
                })
              ).toLocaleDateString("es-ES")}
            </p>
            <p>$ x km</p>
            <ResultadoLine></ResultadoLine>
            <strong>
              <p>Bus Doble: ${costoBusDobleData}</p>
            </strong>
            <ResultadoLine></ResultadoLine>
            <strong>
              <p>Bus40: ${costoBus40Data}</p>
            </strong>
            <ResultadoLine></ResultadoLine>
            <strong>
              <p>MiniBus: ${costoMiniBusData}</p>
            </strong>
            <ResultadoLine></ResultadoLine>
            <strong>
              <p>Van19: ${costoVan19Data}</p>
            </strong>
          </div>
          <div>
            <h5>Viáticos:</h5>
            <strong>
              <p>NACIONAL</p>
            </strong>
            <ResultadoTotal>
              <strong>$ {totalViaticosNacionales}</strong>
            </ResultadoTotal>
            <ResultadoLine></ResultadoLine>
            <strong>
              <p>INTERNACIONAL</p>
            </strong>
            <ResultadoTotal>
              <strong>$ {totalViaticosInternacionales}</strong>
            </ResultadoTotal>
            <ResultadoLine></ResultadoLine>
            <strong>
              <p>PROVINCIAL</p>
            </strong>
            <ResultadoTotal>
              <strong>$ {viaticoProvincial}</strong>
            </ResultadoTotal>
          </div>
        </ContenedorDiv>
      </ResultadoCostoViatico>
      <ContenedorFormBase>
        <h4>Calculadora de Costos</h4>
        <form>
          <p>Kms anuales Bus Doble: 150.000 - Bus40: 90.000 - Van19: 65.000</p>
          <FormGroup>
            <label>Tipo de Bus:</label>
            <select value={bus} onChange={(e) => setBus(e.target.value)}>
              <option value="BusDoble">Bus Doble</option>
              <option value="Bus40">Bus40</option>
              <option value="Van19">Van19</option>
            </select>
          </FormGroup>
          <p>Ref. Bus Doble u$449.000 - Bus40 u$290.000 - Van19 u$135.656</p>
          <FormGroup>
            <label>Costo de Adquisición usd:</label>
            <input
              type="number"
              value={costoAdquisicion}
              onChange={(e) => setCostoAdquisicion(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Precio Dolar MEP:</label>
            <input
              type="number"
              value={precioDolar}
              onChange={(e) => setPrecioDolar(e.target.value)}
            />
          </FormGroup>
          <p>Van19 Gasoil euro</p>
          <FormGroup>
            <label>Precio Combustible:</label>
            <input
              type="number"
              value={precioCombustible}
              onChange={(e) => setPrecioCombustible(e.target.value)}
            />
          </FormGroup>
          <p>Consumo Bus Doble: 0.45 - Bus40: 0.30 - Van19: 0.08</p>
          <FormGroup>
            <label>Consumo:</label>
            <input
              type="number"
              value={consumo}
              onChange={(e) => setConsumo(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Precio Urea x litro:</label>
            <input
              type="number"
              value={precioUrea}
              onChange={(e) => setPrecioUrea(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Precio Lubricante x litro:</label>
            <input
              type="number"
              value={precioLubricante}
              onChange={(e) => setPrecioLubricante(e.target.value)}
            />
          </FormGroup>
          <p>BusDoble (8u.): Neumático 385/65r22.5</p>
          <p>Bus40 (6u.): Neumático 295/80r22.5</p>
          <p>Van19 (6u.): Neumático 195/75r16c 107/105r Sprinter</p>
          <FormGroup>
            <label>Costo Cubiertas x unidad:</label>
            <input
              type="number"
              value={costoCubiertas}
              onChange={(e) => setCostoCubiertas(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Seguro ($ x km Fedeeac):</label>
            <input
              type="number"
              value={seguroMensual}
              onChange={(e) => setSeguroMensual(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Patente ($ x km Fedeeac):</label>
            <input
              type="number"
              value={impuestoAutomotor}
              onChange={(e) => setImpuestoAutomotor(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <label>Sueldo personal (mes):</label>
            <input
              type="number"
              value={sueldoPersonal}
              onChange={(e) => setSueldoPersonal(e.target.value)}
            />
          </FormGroup>

          <FormGroup>
            <label>Viaticos:</label>
            <select
              value={viaticosJornadaCompleta}
              onChange={(e) => setViaticosJornadaCompleta(e.target.value)}
            >
              <option value={viaticoProvincial}>Provincial</option>
              <option value={totalViaticosNacionales}>Nacional</option>
              <option value={totalViaticosInternacionales}>
                Internacional
              </option>
            </select>
          </FormGroup>

          <FormGroup>
            <label>Peajes a CABA solo ida:</label>
            <input
              type="number"
              value={peajes}
              onChange={(e) => setPeajes(e.target.value)}
            />
          </FormGroup>

          <EstiloButton type="button" onClick={calcularCostos}>
            Calcular
          </EstiloButton>
        </form>
      </ContenedorFormBase>

      {calculated && (
        <ResultadoCosto>
          <ResultadoCostoTexto>
            <h5>Costo {bus}:</h5>
            <p>
              Costo Financiero:{" "}
              <strong>
                {costoFinanciero.toLocaleString("es-AR", {
                  style: "currency",
                  currency: "ARS",
                })}
              </strong>
            </p>
            <p>
              Combustible:{" "}
              <strong>
                {combustible.toLocaleString("es-AR", {
                  style: "currency",
                  currency: "ARS",
                })}
              </strong>
            </p>
            <p>
              Urea:{" "}
              <strong>
                {costoUrea.toLocaleString("es-AR", {
                  style: "currency",
                  currency: "ARS",
                })}
              </strong>
            </p>
            <p>
              Neumáticos:{" "}
              <strong>
                {neumaticos.toLocaleString("es-AR", {
                  style: "currency",
                  currency: "ARS",
                })}
              </strong>
            </p>
            <p>
              Patente y Tasas:{" "}
              <strong>
                {impuestos.toLocaleString("es-AR", {
                  style: "currency",
                  currency: "ARS",
                })}
              </strong>
            </p>
            <p>
              Personal:{" "}
              <strong>
                {personal.toLocaleString("es-AR", {
                  style: "currency",
                  currency: "ARS",
                })}
              </strong>
            </p>
            <p>
              Seguro:{" "}
              <strong>
                {seguro.toLocaleString("es-AR", {
                  style: "currency",
                  currency: "ARS",
                })}
              </strong>
            </p>
            <p>
              Viaticos:{" "}
              <strong>
                {viaticos.toLocaleString("es-AR", {
                  style: "currency",
                  currency: "ARS",
                })}
              </strong>
            </p>
            <p>
              Lubricante:{" "}
              <strong>
                {lubricante.toLocaleString("es-AR", {
                  style: "currency",
                  currency: "ARS",
                })}
              </strong>
            </p>
            <p>
              Mantenimiento:{" "}
              <strong>
                {mantenimiento.toLocaleString("es-AR", {
                  style: "currency",
                  currency: "ARS",
                })}
              </strong>
            </p>
            <p>
              Peaje:{" "}
              <strong>
                {peajesGastos.toLocaleString("es-AR", {
                  style: "currency",
                  currency: "ARS",
                })}
              </strong>
            </p>
            <p>
              Gastos Varios:{" "}
              <strong>
                {gastosVarios.toLocaleString("es-AR", {
                  style: "currency",
                  currency: "ARS",
                })}
              </strong>
            </p>
            <ResultadoLine></ResultadoLine>
            <ResultadoTotal>
              <strong>
                Total costo $ x Km:{" "}
                {pesoPorKilometro.toLocaleString("es-AR", {
                  style: "currency",
                  currency: "ARS",
                })}
              </strong>
            </ResultadoTotal>
          </ResultadoCostoTexto>
        </ResultadoCosto>
      )}
    </ContenedorCosto>
  );
};

export default CostCalculadora;
export {
  FormGroup,
  ContenedorCosto,
  ContenedorFormBase,
  ResultadoCosto,
  ResultadoCostoTexto,
  ResultadoLine,
  ResultadoTotal,
};
